import { PkChip, PkIcon } from '@uefadigital/panenka-react';
import { memo, useCallback, useState } from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useStatisticCategory } from '../../hooks/category';

import { useWindowSize } from '@hooks/useWindowSize';
import { useTranslateFn } from '@shared/Translate';

import * as styles from './styles.module.scss';

export const Categories = () => {
  const t = useTranslateFn();

  const [prevEl, setPrevEl] = useState<HTMLDivElement>(null);
  const [nextEl, setNextEl] = useState<HTMLDivElement>(null);
  const { categories, category, setCategory } = useStatisticCategory();
  const { isDesktopExtraLarge } = useWindowSize();

  const handleChip = useCallback(
    (value: string) => () => {
      setCategory(value);
    },
    [setCategory],
  );

  return (
    <div className={styles.wrapper}>
      {!isDesktopExtraLarge && (
        <>
          <div ref={setPrevEl} className={styles.buttonPrev}>
            <PkIcon color='interaction' name='navigation-chevron-left-circle' size={36} />
          </div>
          <Swiper
            modules={[Navigation]}
            slidesPerView='auto'
            spaceBetween={8}
            freeMode={{
              sticky: true,
            }}
            className={styles.slider}
            navigation={{ prevEl, nextEl }}
          >
            {categories.map((c) => (
              <SwiperSlide key={`category_${c}`} className={styles.slide}>
                <PkChip data-testid='carousel-chip' selected={c === category} onPkClick={handleChip(c)}>
                  {t(`stats-cat-${c}`)}
                </PkChip>
              </SwiperSlide>
            ))}
          </Swiper>
          <div ref={setNextEl} className={styles.buttonNext}>
            <PkIcon color='interaction' name='navigation-chevron-right-circle' size={36} />
          </div>
        </>
      )}
      {isDesktopExtraLarge && (
        <div className={styles.itemsFlat}>
          {categories.map((c) => (
            <PkChip
              data-testid='chip'
              selected={c === category}
              onPkClick={handleChip(c)}
              key={`category_${c}`}
              className='item-flat'
            >
              {t(`stats-cat-${c}`)}
            </PkChip>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(Categories);
